import clientsData from '../../jsons/clients.json';
import contractsData from '../../jsons/contracts.json';
import invoicesData from '../../jsons/invoices.json';
import dashboardData from '../../jsons/dashboard.json';
import { Client, Contract, DashboardSnapshot, Invoice } from '../types';

export const clients: Client[] = clientsData as Client[];
export const contracts: Contract[] = contractsData as Contract[];
export const invoices: Invoice[] = invoicesData as Invoice[];
export const dashboard: DashboardSnapshot = dashboardData as DashboardSnapshot;

export const getClientName = (clientId: string): string => {
  const record = clients.find((client) => client.id === clientId);
  return record?.name ?? 'Unknown client';
};

export const currency = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);

export const formatDate = (value: string): string =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(value));
